import fs from 'fs';
import crypto from 'crypto';
import Promise from 'bluebird';
import fetch from 'isomorphic-fetch';
import path from 'path';
import {times} from 'lodash';

Promise.promisifyAll(fs);

class Assembler {
  /*
  fetcher: function(url) => Promise(buffer) :
  checker: function(chunkIndex) => Promise(boolean) : has chunk or not
  */
  constructor(destFile, {fetchConcurrency, fetcher} = {urls: {}}) {
    this.filepath = filepath;
    this.options = {
      fetchConcurrency: fetchConcurrency || 1
    };
    if (fetcher) {
      this.fetcher = fetcher
    } else {
      this.fetcher = url => fetch(url).then(res => res.buffer())
    }
  }

  setFetcher(func) {
    this.fetcher = func;
  }

  check(hashmap) {

  }

  download(hashMap) {
    this.hashMap = hashMap;
    // Check local file
    return fs.readdirAsync(path.resolve(path.basename(this.destFile), '.chunks'))
      .catch((err) => {
        console.log(err.code, err.type, err);
        return [];
      })
      .then((files) => {

      });
    // return Promise.map(this.hashMap, (sha1, index) => {
    //   console.log(sha1, index);
    //   return this.fetcher(index, 0)
    //     .then((buffer) => {
    //       const hash = crypto.createHash('sha1');
    //       hash.update(buf);
    //       return hash.digest('hex');
    //     })
    //     .then(())
    // }, {
    //   concurrency: this.fetchConcurrency
    // });
  }
}

export default Assembler;
